/* eslint-disable camelcase */
import React, { useContext } from 'react';
import { FormContext } from '..';

const OpeningTimes = () => {
  const { opening_hours = {} } = useContext(FormContext);

  return (
    <div className="c-contact-us__hours o-hours">
      <h3 className="c-contact-us__hours__title">{opening_hours.title}</h3>

      <ul className="c-contact-us__hours__list">
        {opening_hours.items.map((item, index) => (
          <li className="c-contact-us__hours__item" key={`open_hour--${index}`}>
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default OpeningTimes;
